module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Rolling-pin-e38ccae83ac10414d5a30dc908d12702.svg";